export default function CapstoneReadyCard() {
  return (
    <div className="rounded-2xl border border-myGreen/30 bg-myGreen/[0.08] p-5">
      <div className="mb-1 text-lg font-semibold text-white">🎓 Tebrikler, tüm müfredatı tamamladın!</div>
      <p className="text-sm text-white/60">
        Bitirme projen için <strong className="text-white/80">eğitmeninle görüş</strong> — yakında bitirme modülün açılacak.
      </p>
    </div>
  );
}
